export default {"id":"15988a8d","attrs":{"viewBox":"0 0 512 512","width":"512","height":"512"}}